
import DrawBase from "../DrawBase"
import EditSector from "./EditSector"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawSector extends DrawBase {

    constructor(options) {
        super(options);
        this.lastX_m = undefined;
        this.lastY_m = undefined;//记录鼠标位置
        this.dir_m = 1; //正向顺时针
    }

    getTypeName() {
        return "扇形";
    }

    getType() {
        return "polygon_Nor";
    }

    getEditInterface() {
        return EditSector;
    }

    checkLeftClick() {
        if (this.positionsTemp.length <= 2) {
            return true;
        }
        return false;
    }


    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positions = [];
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
            }
            positions = positionsArr ? positionsArr : $this.positions;
            return new $this.Cesium.PolygonHierarchy($this.computeSector(positions));

        }, false);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var positions =  JSON.parse(data.editPositions);
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.computeSector(positions));

        }, true);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polygon")
    }

    // leftClick(evt) {

    //     var $this = this;
    //     if (!$this.checkLeftClick()) {
    //         return;
    //     }
    //     var cartesian = this.getCatesian3FromPX(evt.position);
    //     if (!cartesian) {
    //         return;
    //     }
    //     this.lastX_m = undefined;
    //     this.lastY_m = undefined;//
    //     if ($this.positionsTemp.length == 0) {
    //         $this.positionsTemp.push(cartesian.clone());
    //     }

    //     $this.positionsTemp.push(cartesian);
    //     return cartesian;
    // }


    // mouseMove(evt) {
    //     var $this = this;
    //     if (!$this.checkMouseMove()) {
    //         return;
    //     }
    //     var cartesian = $this.getCatesian3FromPX(evt.endPosition);
    //     if (!cartesian) {
    //         return;
    //     }

    //     if ($this.lastX_m && $this.lastY_m) {
    //         var deltaX = evt.endPosition.x - $this.lastX_m;
    //         var deltaY = evt.endPosition.y - $this.lastY_m;
    //         var angle = Math.atan2(deltaY, deltaX) * 180 / Math.PI;
    //         this.dir_m = angle >= 0 ? 1 : -1;
    //     }
    //     $this.lastX_m = evt.endPosition.x;
    //     $this.lastY_m = evt.endPosition.y;

    //     if ($this.isStarted && !$this.Cesium.defined($this.plot)) {
    //         $this.plot = $this.createPlot();
    //         $this.entities.push($this.plot);
    //         if ($this.canEdit) {
    //             $this.initEditor(); //初始化编辑器
    //         }
    //     }
    //     var a = $this.cartesianToLatlng($this.positionsTemp.slice(-1)[0]);
    //     var b = $this.cartesianToLatlng(cartesian);
    //     if ($this.distance(a, b) < 0.000003) {
    //         return;
    //     }
    //     if ($this.plot) {
    //         $this.positionsTemp.pop();
    //         $this.positionsTemp.push(cartesian);
    //     }
    // }


    computeSector(positions) {

        if (positions.length < 3) {
            return positions;
        }

        var c = positions[0];
        var p1 = positions[1];
        var p2 = positions[2];
        var angle = this.getAngleCenterPointDir(c, p1, p2);
        if (isNaN(angle)) {
            return [];
        }
        var list = [];
        let theta = angle * (180 / Math.PI);
        list = [];
        if (theta < 0) {
            theta = theta + 360;
        }
        list.push(c);
        for (var i = 0; i < theta; i += 2) {
            var p = this.getRotateCenterPoint(c, p1, i);
            list.push(p);
        }

        var end = this.getRotateCenterPoint(c, p1, theta);
        list.push(end);
        list.push(c);

        // //逆时针
        // if (this.dir_m < 0) {
        //     list = [];
        //     list.push(c);
        //     for (var i = 0; i > theta; i -= 2) {
        //         var p = this.getRotateCenterPoint(c, p1, i);
        //         list.push(p);
        //     }

        //     var end = this.getRotateCenterPoint(c, p1, theta);
        //     list.push(end);
        //     list.push(c);
        // }

        // if (this.dir_m > 0) {
        //     list = [];
        //     if (theta < 0) {
        //         theta = theta + 360;
        //     }
        //     console.log(theta)
        //     list.push(c);
        //     for (var i = 0; i < theta; i += 2) {
        //         var p = this.getRotateCenterPoint(c, p1, i);
        //         list.push(p);
        //     }

        //     var end = this.getRotateCenterPoint(c, p1, theta);
        //     list.push(end);
        //     list.push(c);
        // }



        return list;
    }


    getRotateCenterPoint(center, point1, angle) {
        // 计算center的地面法向量
        var chicB = Cesium.Cartographic.fromCartesian(center);
        chicB.height = 0;
        var dB = Cesium.Cartographic.toCartesian(chicB);

        var chicC = Cesium.Cartographic.fromCartesian(center);
        chicC.height = 10;
        var dC = Cesium.Cartographic.toCartesian(chicC);

        var normaB = Cesium.Cartesian3.normalize(
            Cesium.Cartesian3.subtract(dB, dC, new Cesium.Cartesian3()),
            new Cesium.Cartesian3()
        );

        // 构造基于center的法向量旋转angle度的矩阵
        var Q = Cesium.Quaternion.fromAxisAngle(normaB, Cesium.Math.toRadians(angle));
        var m3 = Cesium.Matrix3.fromQuaternion(Q);
        var m4 = Cesium.Matrix4.fromRotationTranslation(m3);

        // 计算point1点相对center点的坐标A1
        var A1 = Cesium.Cartesian3.subtract(point1, center, new Cesium.Cartesian3());

        //对A1应用旋转矩阵
        var p = Cesium.Matrix4.multiplyByPoint(m4, A1, new Cesium.Cartesian3());
        // 新点的坐标
        var pointNew = Cesium.Cartesian3.add(p, center, new Cesium.Cartesian3());

        return pointNew;
    }

}

export default DrawSector;